/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
$("button.Collapsible__Button").click(function(){$(this).parents('.Collapsible').siblings().children('button.Collapsible__Button').removeClass('active_tab');$(this).toggleClass('active_tab');});
$('document').ready (function(){
    selecttag();
});
function selecttag(){
    $('button[data-action="toggle-tag"]').on('click',function(){
        var currenttagname = $(this).text();
        var currentdatatagname = $(this).attr('data-tag');
        var currentdatatagnamenew = currentdatatagname.split("_"); 
        var currentdatatagnamenew = currentdatatagnamenew[0];
        var currentdatatagnamenew = currentdatatagnamenew.toLowerCase();
        var currentclassname = $('body ul#select-filter-list li' + '.' + currentdatatagnamenew );
        if($('body ul#select-filter-list').find('li').hasClass(currentdatatagnamenew)){
            if($(this).hasClass('is-active')){
                $(currentclassname).remove();
            }
            else{
                $(currentclassname).text();
                $(currentclassname ).text(currenttagname);
            }
        }
        else{
            $('body ul#select-filter-list').append(
                '<li class=' + '"' + currentdatatagnamenew + '"' + '>'+ currenttagname + '</li>');
        }
    });
    $('button[data-action="reset-tags"]').on('click',function(){
      $('body #select-filter-list').empty();
    });
    $('.close-current-filter').on('click',function(){
        $(this).parent('li').remove();
    });
}
function variantplp(el) {  
    // alert( this.value );
    var url=$(el).attr('option_url'),
    img_url=$(el).attr('img_url');
    console.log(img_url,'ursel',url);
    if(img_url != undefined){ $(el).closest('.ProductItem__Wrapper').find('img.ProductItem__Image').attr('src',img_url);}
    $(el).closest('.ProductItem__Wrapper').find('.customurl').attr('href',url);
    $(el).closest('.ProductItem__Wrapper').children('a').attr('href',url);
}